/*
 *  types.ts
 *
 *	The most basic/foundamental types/interfaces
 *	for EQIT typescript WebUI implementation.
 *
 *  Copyright (C) 2022-2024, EQIT. All rights reserved.
 *  Created by David Hsieh <david@eqit.com.tw>
 */
/**
 * The log levels of eqlogging.
 */
export var E_LOGLEVEL;
(function (E_LOGLEVEL) {
    E_LOGLEVEL[E_LOGLEVEL["NONE"] = 0] = "NONE";
    E_LOGLEVEL["TRACE"] = "TRACE";
    E_LOGLEVEL["DEBUG"] = "DEBUG";
    E_LOGLEVEL["INFO"] = "INFO";
    E_LOGLEVEL["WARNING"] = "WARNING";
    E_LOGLEVEL["ERROR"] = "ERROR";
})(E_LOGLEVEL || (E_LOGLEVEL = {}));
export var E_COLUMN_TYPE;
(function (E_COLUMN_TYPE) {
    E_COLUMN_TYPE[E_COLUMN_TYPE["NONE"] = 0] = "NONE";
    E_COLUMN_TYPE["PARAGRAPH"] = "PARAGRAPH";
    E_COLUMN_TYPE["LINEBREAK"] = "LINEBREAK";
    E_COLUMN_TYPE["HORIZONTAL"] = "HORIZONTAL";
    E_COLUMN_TYPE["STATIC"] = "STATIC";
    E_COLUMN_TYPE["BOOLEAN"] = "BOOLEAN";
    E_COLUMN_TYPE["TEXT"] = "TEXT";
    E_COLUMN_TYPE["ITEXT"] = "ITEXT";
    E_COLUMN_TYPE["MLTEXT"] = "MLTEXT";
    E_COLUMN_TYPE["PASSWORD"] = "PASSWORD";
    E_COLUMN_TYPE["NUMERIC"] = "NUMERIC";
    E_COLUMN_TYPE["MACADDR"] = "MACADDR";
    E_COLUMN_TYPE["IPADDR"] = "IPADDR";
    E_COLUMN_TYPE["IPNET"] = "IPNET";
    E_COLUMN_TYPE["IPHOST"] = "IPHOST";
    E_COLUMN_TYPE["IPSCOPE"] = "IPSCOPE";
    E_COLUMN_TYPE["ENUM"] = "ENUM";
    E_COLUMN_TYPE["ENUMINT"] = "ENUMINT";
    E_COLUMN_TYPE["DURATION"] = "DURATION";
    E_COLUMN_TYPE["DATE"] = "DATE";
    E_COLUMN_TYPE["DATETIME"] = "DATETIME";
    E_COLUMN_TYPE["TIMEOFDAY"] = "TIMEOFDAY";
    E_COLUMN_TYPE["TIMESTAMP"] = "TIMESTAMP";
    E_COLUMN_TYPE["TEXTAREA"] = "TEXTAREA";
    E_COLUMN_TYPE["DAYS6Y"] = "DAYS6Y";
    E_COLUMN_TYPE["WEEKDAY"] = "WEEKDAY";
    E_COLUMN_TYPE["TIMERANGE"] = "TIMERANGE";
    E_COLUMN_TYPE["EXTEND"] = "EXTEND";
})(E_COLUMN_TYPE || (E_COLUMN_TYPE = {}));
export var E_SFILTER_TYPE;
(function (E_SFILTER_TYPE) {
    E_SFILTER_TYPE[E_SFILTER_TYPE["NONE"] = 0] = "NONE";
    E_SFILTER_TYPE["BOOLEAN"] = "BOOLEAN";
    E_SFILTER_TYPE["TEXT"] = "TEXT";
    E_SFILTER_TYPE["ITEXT"] = "ITEXT";
    E_SFILTER_TYPE["MLTEXT"] = "MLTEXT";
    E_SFILTER_TYPE["NUMERIC"] = "NUMERIC";
    E_SFILTER_TYPE["FLOAT"] = "FLOAT";
    E_SFILTER_TYPE["MACADDR"] = "MACADDR";
    E_SFILTER_TYPE["MACADDRS"] = "MACADDRS";
    E_SFILTER_TYPE["IPSCOPE"] = "IPSCOPE";
    E_SFILTER_TYPE["ENUMINT"] = "ENUMINT";
    E_SFILTER_TYPE["ENUM"] = "ENUM";
    E_SFILTER_TYPE["DURATIONRANGE"] = "DURATIONRANGE";
    E_SFILTER_TYPE["DATERANGE"] = "DATERANGE";
    E_SFILTER_TYPE["DATETIMERANGE"] = "DATETIMERANGE";
    E_SFILTER_TYPE["TIMERANGE"] = "TIMERANGE";
    E_SFILTER_TYPE["TIMESTAMPRANGE"] = "TIMESTAMPRANGE";
    E_SFILTER_TYPE["DN"] = "DN";
    E_SFILTER_TYPE["GRPID"] = "GRPID";
    E_SFILTER_TYPE["TEXTAREA"] = "TEXTAREA";
})(E_SFILTER_TYPE || (E_SFILTER_TYPE = {}));
export var E_NVITEM_TYPE;
(function (E_NVITEM_TYPE) {
    E_NVITEM_TYPE[E_NVITEM_TYPE["NONE"] = 0] = "NONE";
    E_NVITEM_TYPE["PARAGRAPH"] = "P";
    E_NVITEM_TYPE["LINEBREAK"] = "BR";
    E_NVITEM_TYPE["HORIZONTAL"] = "HR";
    E_NVITEM_TYPE["STATIC"] = "nvStatic";
    E_NVITEM_TYPE["TEXT"] = "nvText";
    E_NVITEM_TYPE["PASSWORD"] = "nvPassword";
    E_NVITEM_TYPE["INTEGER"] = "nvInteger";
    E_NVITEM_TYPE["NUMERIC"] = "nvNumeric";
    E_NVITEM_TYPE["MLTEXT"] = "nvMLText";
    E_NVITEM_TYPE["FILE"] = "nvFile";
    E_NVITEM_TYPE["TEXTAREA"] = "nvTextarea";
    E_NVITEM_TYPE["SELECT"] = "nvSelect";
    E_NVITEM_TYPE["SELECT2"] = "nvSelect2";
    E_NVITEM_TYPE["IPNET"] = "nvIPNet";
    E_NVITEM_TYPE["IPSCOPE"] = "nvIPScope";
    E_NVITEM_TYPE["MACADDRS"] = "nvMACAddrs";
    E_NVITEM_TYPE["RANGE"] = "nvRange";
    E_NVITEM_TYPE["DURATION"] = "nvDuration";
    E_NVITEM_TYPE["DURATIONRANGE"] = "nvDurationRange";
    E_NVITEM_TYPE["DATETIMEPICKER"] = "nvDateTimePicker";
    E_NVITEM_TYPE["DATETIMERANGE"] = "nvDateTimeRange";
    E_NVITEM_TYPE["BUTTON"] = "nvButton";
    E_NVITEM_TYPE["BOOLEAN"] = "nvBoolean";
    E_NVITEM_TYPE["WEEKDAY"] = "nvWeekDay";
    E_NVITEM_TYPE["TIMEINDAY"] = "nvTimeInDay";
    E_NVITEM_TYPE["TIMERANGEINDAY"] = "nvTimeRangeInDay";
    E_NVITEM_TYPE["EXTEND"] = "nvExtend";
})(E_NVITEM_TYPE || (E_NVITEM_TYPE = {}));
